export const waypointsToGpx = (waypoints: any[]) => {
  const wpts = waypoints.map((waypoint, index) => {
    return `<wpt lat="${waypoint[0]}" lon="${waypoint[1]}">
      <name>Waypoint ${index}</name>
    </wpt>`
  })

  return `<?xml version="1.0"?><gpx version="1.1">${wpts}</gpx>`
}
